import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            {aboutData.title}
          </h2>
          <div className="space-y-4 mb-10">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold mb-1" style={{ color: 'oklch(var(--primary-500))' }}>
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}